class PhoneNumberFormat {
    constructor(){
    }

    format(phoneNumber){
        if(typeof(phoneNumber) === 'string') {
            switch(phoneNumber.length) {
                case 9:
                    return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
                case 10:
                    if(phoneNumber.startsWith('02') === true) {
                        return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
                    } else {
                        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                    }
                case 11:
                    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
                default:
                    return phoneNumber;
            }
        } else {
            return phoneNumber;
        }
    }
}

export default PhoneNumberFormat;